import React, { useState } from 'react';
import CompanyName from '../../commonComponents/CompanyName';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import { HeritierType } from '../../../static/types/commonTypes/individualType';
import Officiant from '../../commonComponents/NotaitreOfficiant';
import { LegalEntityType, LegalEntityTypeOfficiant, Tribunal } from '../../../static/types/commonTypes/legalEntityType';
import TribunalJudiciaire from '../../commonComponents/TribunalJudiciaire';
import HeritierList from '../../commonComponents/HeritierList';
import ChangeSocialObject from '../../change-social-object/ChangeSocialObject';
import { ChangeSocialObjectType } from '../../../static/types/changeSocialObjective/changeSocialObjectType';
import Decedes from '../../commonComponents/personeeDecede';
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { formatObjectText } from '../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;

}

const AcceptationDeLaSuccession: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
    updatesocieteSelected
}) => {


    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,



        dateNotary, setdateNotary,
        dateValidityNotary, setdateValidityNotary,
        dateCheckedNotary, setdateCheckedNotary,


        checkedofficiant, setcheckedofficiant,
        legalEntityofficiant, setlegalEntityofficiant,
        companyNameofficiant, setcompanyNameofficiant,
        officiantValidity, setofficiantValidity,


        checkedtribunal, setcheckedtribunal,
        Tribunal, setTribunal,
        DateTribunal, setDateTribunal,
        tribunalValidity, settribunalValidity,

        individualPersonsHeritier, setIndividualPersonsHeritier,
        individualPersonsValidityHeritier, setIndividualPersonsValidityHeritier,
        individualPersonsCheckedHeritier, setIndividualPersonsCheckedHeritier,


        changeSocialObject, setChangeSocialObject,
        changeSocialObjectValidity, setChangeSocialObjectValidity,
        changeSocialObjectChecked, setChangeSocialObjectChecked,


        personneeDecede, setpersonneeDecede,
        personneeDecedechecked, setpersonneeDecedechecked,
        personneeDecedeValidity, setpersonneeDecedeValidity,

        datedeces, setdatedeces,
        datecheckedDeces, setdatecheckedDeces,
        dateValidityDeces, setDateValidityDeces,

        individual, setIndividual,
        individualValidity, setIndividualValidity,
        individualChecked, setIndividualChecked,

    } = useAppContext() as AppContextType
    const [errors, setErrors] = useState<{ denomination?: string; texteAnnonce?: string }>({});
    const [isTextareaVisible, setIsTextareaVisible] = useState(false);
    const [activeTab, setActiveTab] = useState<string>('raisonSociale');
    const [visitedTabs, setVisitedTabs] = useState(['raisonSociale']);
    const [formSubmitted, setFormSubmitted] = useState(false);


    // Raison Social
    const updateCompanyNameValidity = (isValid: boolean) => setCompanyNameValidity(isValid);
    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });
    const updateDeces = (data: Partial<LegalEntityType>) => setpersonneeDecede({ ...personneeDecede, ...data })
    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }

    const validate = () => {
        const newErrors: {
            denomination1?: string;
            ville?: string;
            greffe?: string;
            objetsocial?: string;
            texteAnnonce?: string;
        } = {};


        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const switchTab = (tab: string) => {
setActiveTab(tab);
    };

    const [formData, setFormData] = useState({
        denomination1: '',
    })
    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType]

    const [submittedData, setSubmittedData] = useState<{ [key: string]: string } | null>(null);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (validate()) {
            const heritiertext = individualPersonsHeritier.map ((individualHeritier:HeritierType) => `${individualHeritier.civility === 'Monsieur' ? 'M.' : 'Mme.'} ${individualHeritier.firstName} né ${individualHeritier.birthName} ${individualHeritier.lastName} ${individualHeritier.address} ${individualHeritier.additionalAddress ? `${individualHeritier.additionalAddress}` : ``} ${individualHeritier.postalCode} ${individualHeritier.city} exerçant la profession de ${individualHeritier.profession}, en la qualité de héritier légal`).join(", ")


            const tempText = `Suivant acte, reçu par ${legalEntityofficiant.civility} ${legalEntityofficiant.nom} ${legalEntityofficiant.prenom} ${legalEntityofficiant.decisionNature} ${legalEntityofficiant.legalForm} ${legalEntityofficiant.Denomination}, titulaire d'un office notarial à ${legalEntityofficiant.address} ${legalEntityofficiant.additionalAddress} ${legalEntityofficiant.postalCode} ${legalEntityofficiant.city}, a été reçue le ${dateNotary.date} l'acceptation à concurrence de l'actif net de la succession de M. ${individual.firstName}  ${individual.lastName} , demeurant à  ${individual.address}   ${individual.additionalAddress}   ${individual.postalCode}   ${individual.city} , décédé le ${datedeces.date} à (), par :
${heritiertext},
${changeSocialObject.socialObject},
La déclaration d'acceptation de l'actif net a été régulièrement déposée au greffe du Tribunal Judiciaire de ${Tribunal.greffe} le ${Tribunal.dateDépot} sous le numéro ${Tribunal.numeroRole}.
Les oppositions des créanciers, s'il y a lieu, seront reçues dans les quinze mois de la date de l'insertion au BODACC, en l'office notarial où domicile a été élu à cet effet.
Pour insertion.
Le notaire.`
            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
        }
    };

    const [submissive, setSubmissive] = useState<boolean>(false)

    const handleNext = () => {
        if (activeTab === "raisonSociale") {
            setCompanyNameChecked(true);
            if (companyNameValidity) {
                const nextTab = getNextTab("raisonSociale");
                switchTab(nextTab);
            }
        }
        else if (activeTab === "signatureDesStatus") {
            setpersonneeDecedechecked(true);
            setIndividualChecked(true);
            setdatecheckedDeces(true);
            if (personneeDecedeValidity || dateValidityDeces || personneeDecedeValidity) {
                const nextTab = getNextTab("signatureDesStatus");
                switchTab(nextTab);
            }
        }
        else if (activeTab === "notary") {
            setcheckedofficiant(true);
            setdateCheckedNotary(true)
            if (officiantValidity || dateValidityNotary) {
                switchTab(getNextTab("notary"))
            }
        }
        else if (activeTab === "adresseDuSiegeSocial") {
            setcheckedtribunal(true);
            if (tribunalValidity) {
                const nextTab = getNextTab("adresseDuSiegeSocial");
                switchTab(nextTab);
            }
        }
        else if (activeTab === "laGérance") {
            setIndividualPersonsCheckedHeritier(true);
            if (individualPersonsValidityHeritier) {
                const nextTab = getNextTab("laGérance");
                switchTab(nextTab);
            }
        }
        else if (activeTab === "mentions") {
            setChangeSocialObjectChecked(true);
            if (changeSocialObjectValidity) {
                setSubmissive(true);
            }
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };


    const getNextTab = (currentTab: string) => {
        switch (currentTab) {
            case 'raisonSociale':
                return 'signatureDesStatus';
            case 'signatureDesStatus':
                return 'notary';
            case 'notary':
                return 'adresseDuSiegeSocial';
            case 'adresseDuSiegeSocial':
                return 'laGérance';
            case 'laGérance':
                return 'mentions';
            default:
                return currentTab;
        }
    };

    const getPreviousTab = (currentTab: string) => {
        switch (currentTab) {
            case 'signatureDesStatus':
                return 'raisonSociale';
            case 'notary':
                return 'signatureDesStatus';
            case 'adresseDuSiegeSocial':
                return 'notary';
            case 'laGérance':
                return 'adresseDuSiegeSocial';
            case 'mentions':
                return 'laGérance'
            default:
                return currentTab;
        }
    };

    const tabs = [
        {key: 'raisonSociale', label: 'Raison Sociale'},
        {key: 'signatureDesStatus', label: "Etat civil de la personne décédée"},
        {key: 'notary', label: 'Notaire officiant'},
        {key: 'adresseDuSiegeSocial', label: "Inscription de la déclaration d'acceptation au registre tenu par le tribunal judiciaire"},
        {key: 'laGérance', label: 'Les héritiers qui ont déclaré accepter la succession'},
        {key: 'mentions', label: 'mentions optionnelles supplémentaires'},

    ]

    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <form onSubmit={handleSubmit}>
                {
                    activeTab === "raisonSociale" &&
                    <CompanyName
                        changeCompanyName={updateCompanyName}
                        checked={companyNameChecked}
                        companyName={companyName}
                        onValidationChange={updateCompanyNameValidity}
                    />
                }
                {activeTab === 'signatureDesStatus' && (
                    <>
                        <Decedes
                            checkedDecede={personneeDecedechecked}
                            decedes={personneeDecede}
                            changeDecede={updateDeces}
                            onValidationChangeDecedes={(isValid: boolean) => setpersonneeDecedeValidity(isValid)}
                        />
                    </>
                )}

                {activeTab === 'notary' && (
                    <Officiant
                        checkedofficiant={checkedofficiant}
                        legalEntityofficiant={legalEntityofficiant}
                        societyType={societyTypeOptions}
                        changeLegalEntityofficiant={(data: Partial<LegalEntityTypeOfficiant>) => setlegalEntityofficiant({ ...legalEntityofficiant, ...data })}
                        decisionNatureOptions={[
                            "",
                            "Notaire associé",
                            "Notaire exerçant à titre individuel",
                            "Autre",
                        ]}
                        onValidationChangeofficiant={(isValid: boolean) => setofficiantValidity(isValid)}
                    />
                )}
                {activeTab === 'adresseDuSiegeSocial' && (
                    <TribunalJudiciaire
                        checkeTribunal={checkedtribunal}
                        Tribunal={Tribunal}
                        changeTribunal={(data: Partial<Tribunal>) => setTribunal({ ...Tribunal, ...data })}
                        onValidationChangeTribunal={(isValid: boolean) => settribunalValidity(isValid)}
                    />
                )}
                {activeTab === 'laGérance' && (
                    <>
                        <HeritierList
                            labelItem='Héritier'
                            checkedHeritier={individualPersonsCheckedHeritier}
                            heritier={individualPersonsHeritier}
                            setHeritier={setIndividualPersonsHeritier}
                            setHeritierValidity={setIndividualPersonsValidityHeritier}
                            addButtonText='Ajouter un heritier'
                            removeButtonText='Supprimer le dernier heritier'
                        />
                    </>
                )}
                {
                    activeTab === 'mentions' && (
                        <>
                            <ChangeSocialObject
                                labelText='mentions'
                                showTypeSelect={false}
                                showRequiredIndicator={false}
                                checked={changeSocialObjectChecked}
                                socialObject={changeSocialObject}
                                onValidationChange={(isValid: boolean) => setChangeSocialObjectValidity(isValid)}
                                changeSocialObject={(partialData: Partial<ChangeSocialObjectType>) => setChangeSocialObject({ ...changeSocialObject, ...partialData })}
                            />
                            {
                                submissive &&
                                <div className="mt-4">
                                    <h4>Texte de l'annonce:</h4>
                                    <textarea
                                        className="form-control"
                                        rows={5}
                                        value={txtAnnonce}
                                        disabled
                                    />
                                </div>
                            }
                        </>

                    )
                }
                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== "raisonSociale" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handlePrevious}
                            >
                                <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                Modifier mon annonce
                            </button>
                        }
                        {
                            activeTab === "mentions" &&
                            <button type="submit"
                                onClick={handleNext}>
                                Mettre à jour mon annonce
                                <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                            </button>
                        }
                        {
                            activeTab !== "mentions" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handleNext}>
                                Suivant
                                <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            submissive &&
                            activeTab === "mentions" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={goToSupportPresse}
                            >
                                Sélection du support
                                <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }
                    </div>
                </div>
            </form>
        </>
    );
};

export default AcceptationDeLaSuccession;